import { convertQuotesToEntity } from 'utils/string'
import { getHrefExternal } from 'utils/url'
import { IListItems, IItem } from '../list-interface'

export const LIST_WIDGET_NO_ITEMS =
    'Sorry, no articles could be found for this list.'
export const LIST_WIDGET_NOT_ENOUGH_ITEM = 'Items are not enough'

const renderArticlesList = (
    props: IListItems,
    maxItems: number,
    minItems: number
): string => {
    const { items } = props

    // Limit the items to display
    const limitedItems = items.slice(0, maxItems)

    if (items.length < minItems) {
        return LIST_WIDGET_NOT_ENOUGH_ITEM
    }

    const renderedItems = limitedItems
        .map((item: IItem, index: number) => {
            const id = item._id || ''
            const title = convertQuotesToEntity(
                item.title || (item.titles && item.titles.main) || ''
            )
            const url = item.get_html_canonical_url || item.origin_url || ''

            const dataEvtVal = {
                control_fields: {
                    mparticle: {
                        keys: {
                            click_source_type: 'click_source_type',
                            anchor_text: 'anchor_text',
                            widget_title: 'widget_title',
                            target_url: 'target_url',
                            target_article_title: 'target_article_title',
                            target_article_id: 'target_article_id',
                            target_article_position: 'target_article_position'
                        },
                        mp_event_type: 'Navigation',
                        extra_keys: [
                            'click_vertical_position_percentage',
                            'click_vertical_position_pixels'
                        ]
                    }
                },
                click_source_type: 'widget-list',
                anchor_text: title,
                widget_title: 'News Releases',
                target_url: url,
                target_article_title: title,
                target_article_id: id,
                target_article_position: index
            }
            const clickEvent = `data-evt="click" data-evt-typ="click" data-evt-val='${JSON.stringify(
                dataEvtVal
            )}'`

            // Determine if the given link is internal or external
            // set title (leaving hostname) for external urls
            let target = ''
            if (getHrefExternal(url)) {
                target = `title="${title} (Leaving ${window.location.hostname})"`
            }

            return `
                <li data-article-id="${id}">
                    <a href="${url}" ${target} ${clickEvent}>${title}</a>
                </li>`
        })
        .join('')

    return `
        <ul class="list-widget__articles-list">
        ${renderedItems}
        </ul>`
}

export const renderGlobeNewsWireWidget = (
    props: IListItems,
    maxItems: number,
    minItems: number
): string => {
    return renderArticlesList(props, maxItems, minItems)
}
